module.exports = __webpack_public_path__ + "img/cloth_g1_hat_05.5b9be838.svg";